import script from "./ComVarmistus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComVarmistus.vue?vue&type=script&setup=true&lang=ts"

import "./ComVarmistus.vue?vue&type=style&index=0&id=68b05824&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b05824"]])

export default __exports__